<template lang='pug'>
  .variant-card.product-card(
    v-if='variant && product'
    @mouseenter='mouseoverVariantCard'
    @mouseleave='mouseleaveVariantCard'
    :data-product-id='product.id'
    :data-product-name='product.attributes.name'
    :data-product-brand='variant.attributes["brand-name"]'
    :data-variant-id='variant.id'
  )
    router-link.product-card-image-container(:to='variantShowRoute')
      img.product-card-image(:src='variantImage')
      .out-of-stock(v-if='variant.attributes["sold-out"]' v-t='"products.outOfStock"')

    .variant-card-actions(:class='showVariantActions ? "visible" : "invisible"' v-if='variant && hasShownVariantActions && product')
      product-call-to-action.call-to-action(:variant='variant' :product='product' size='sm')

    router-link.product-card-description(:to='variantShowRoute')
      p.product-card-label(v-if='variant.attributes["new-arrival"]')
        span.product-card-label-primary(v-t='"common.new"')
      p.product-card-brand(v-text='variant.attributes["brand-name"]')
      p.product-card-product(v-text='variant.attributes["product-name"]')

      ProductPrice(:variant='variant')

      .rating-container(v-if='variant.attributes.rating > 0')
        product-rating-stars(:rating='variant.attributes.rating')
</template>

<script>
import { mapState } from 'vuex'
import ProductCallToAction from '../../products/product-call-to-action.vue'
import ProductRatingStars from '../../products/product-rating-stars.vue'
import ProductPrice from '../../products/product-price.vue'

export default {
  components: {
    ProductCallToAction,
    ProductRatingStars,
    ProductPrice
  },

  props: {
    variant: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showVariantActions: false,
      hasShownVariantActions: false,
      product: {}
    }
  },

  computed: {
    ...mapState({
      landingPageIncluded: state => state.landingPage.landingPageIncluded,
      beautyFeedProducts: state => state.beautyFeedShow.products
    }),
    variantImage () {
      return this.variant.attributes['image-urls'][0] || ''
    },
    variantShowRoute () {
      return {
        name: 'products-show-variant',
        params: {
          id: this.product.attributes['slug-url'],
          variantId: this.variant.attributes['slug-url']
        }
      }
    }
  },

  created () {
    const productId = this.variant.relationships['product'].data.id
    if (this.$route.name === 'beautyfeed-show') {
      this.product = this.beautyFeedProducts.find(product => product.id === productId)
    } else {
      this.product = this.landingPageIncluded.find(included => included.id === productId)
    }
  },

  methods: {
    mouseoverVariantCard () {
      this.showVariantActions = true
      this.hasShownVariantActions = true
    },

    mouseleaveVariantCard () {
      this.showVariantActions = false
    }
  }
}
</script>

<style scoped lang='scss'>
  .variant-card {
    margin-top: 20px;
    margin-bottom: 20px;
    position: relative;
    padding-left: 5px;
    padding-right: 5px;
    max-width: 185px;

    .variant-card-actions {
      position: relative;
    }

    .call-to-action {
      position: absolute;
      bottom: 15px;
      top: auto;
      width: 100%;
      height: 30px;
    }

    .product-card-brand,
    .product-card-product {
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
</style>
